// CSV columns for a meeting-form JSON schema (assets/meeting-form/<schema>.json): one per question,
// skipping info-only entries (value ""), plus the "<question> - Other" field that tick-box adds
// for answers containing "(please specify)".
export function schemaColumns(schema: string): string[] {
  const questions: any[] = require(`assets/meeting-form/${schema}.json`)['questions']
  const columns: string[] = []
  for (const question of questions) {
    const key = Object.keys(question)[0]
    const value = question[key]
    if (!value) continue
    columns.push(key)
    if (Array.isArray(value) && value.some((answer: string) => /\(please specify\)/i.test(answer)))
      columns.push(`${key} - Other`)
  }
  return columns
}
